// Elemente auswählen
const imgWidthValueElem = document.getElementById('image-width-value');
const imgPreviewElem = document.querySelector('.preview_image-svg');
const imgPlusBtn = document.querySelector('.image-styling__plus');
const imgMinusBtn = document.querySelector('.image-styling__minus');
const imgTopBtn = document.querySelector('.image-styling__top');
const imgBottomBtn = document.querySelector('.image-styling__bottom');
const imgLeftBtn = document.querySelector('.image-styling__left');
const imgRightBtn = document.querySelector('.image-styling__right');
const imgXInput = document.getElementById('image-x-input');
const imgYInput = document.getElementById('image-y-input');
const imgResetBtn = document.querySelector('.image-styling__reset');
const imgRotationInput = document.getElementById('image-rotation-input');
const imgRotateLeftBtn = document.querySelector('.image-styling__rotate-left');
const imgRotateRightBtn = document.querySelector('.image-styling__rotate-right');
const imgResetRotationBtn = document.querySelector('.image-styling__reset-rotation');
const motivTabElem = document.getElementById('motiv_tab'); // Motiv Tab Element

// Default-Felder auswählen
const imgXInputDefault = document.getElementById('image-x-input-default');
const imgYInputDefault = document.getElementById('image-y-input-default');
const imgRotationInputDefault = document.getElementById('image-rotation-input-default');
const imgSizeDefault = document.getElementById('image-size-default');
const imgSizeAdjusted = document.getElementById('image-size-adjusted');

// Funktion, um #motiv_tab bei Klick auf .preview_image-svg auszulösen
imgPreviewElem.addEventListener('click', () => {
    motivTabElem.click(); // Simuliert einen Klick auf das Element
});

// Hilfsfunktion für Transformationswerte des Bild-Elements
function getImgTransformValues(element) {
    const style = window.getComputedStyle(element);
    const matrix = new WebKitCSSMatrix(style.transform);

    return {
        x: matrix.m41,
        y: matrix.m42,
        rotation: Math.round(Math.atan2(matrix.m21, matrix.m11) * (180 / Math.PI))
    };
}

// Initiale Werte abrufen
let imgInitialPosition = getImgTransformValues(imgPreviewElem);
let imgXPosition = imgInitialPosition.x;
let imgYPosition = imgInitialPosition.y;
let imgRotationAngle = imgInitialPosition.rotation;

// Startwert für Bildbreite in Pixeln
let imgWidthPx = parseInt(imgPreviewElem.getAttribute('width'));
imgWidthValueElem.textContent = imgWidthPx + 'px';

imgXInput.value = imgXPosition + 'px';
imgYInput.value = imgYPosition + 'px';
imgRotationInput.value = imgRotationAngle + 'deg';

// Anfangswerte in die Default-Felder einfügen (nur einmalig, werden nicht mehr angepasst)
imgXInputDefault.value = imgXPosition + 'px';
imgYInputDefault.value = imgYPosition + 'px';
imgRotationInputDefault.value = imgRotationAngle + 'deg';
imgSizeDefault.value = imgWidthPx + 'px';

let imgIntervalId;

// Funktion zur Button-Bedienung (Einzeln klicken und gedrückt halten)
function handleImgButton(button, action) {
    // Für Desktop
    button.addEventListener('mousedown', () => {
        action(); // Aktion sofort ausführen
        imgIntervalId = setInterval(action, 100); // Aktion kontinuierlich alle 100 ms ausführen
    });

    button.addEventListener('mouseup', () => clearInterval(imgIntervalId));
    button.addEventListener('mouseleave', () => clearInterval(imgIntervalId)); // Falls der Button verlassen wird

    // Für Mobile
    button.addEventListener('touchstart', (e) => {
        e.preventDefault(); // Verhindert das Standardverhalten auf Mobilgeräten
        action(); // Aktion sofort ausführen
        imgIntervalId = setInterval(action, 100); // Aktion kontinuierlich alle 100 ms ausführen
    });

    button.addEventListener('touchend', () => clearInterval(imgIntervalId));
}

// Position ändern
handleImgButton(imgTopBtn, () => {
    imgYPosition -= 2;
    updateImgPosition();
});

handleImgButton(imgBottomBtn, () => {
    imgYPosition += 2;
    updateImgPosition();
});

handleImgButton(imgLeftBtn, () => {
    imgXPosition -= 2;
    updateImgPosition();
});

handleImgButton(imgRightBtn, () => {
    imgXPosition += 2;
    updateImgPosition();
});

// Rotation ändern
handleImgButton(imgRotateLeftBtn, () => {
    imgRotationAngle -= 1;
    updateImgRotation();
});

handleImgButton(imgRotateRightBtn, () => {
    imgRotationAngle += 1;
    updateImgRotation();
});

// Input-Felder
imgXInput.addEventListener('input', () => {
    imgXPosition = parseInt(imgXInput.value) || 0;
    updateImgPosition();
});

imgYInput.addEventListener('input', () => {
    imgYPosition = parseInt(imgYInput.value) || 0;
    updateImgPosition();
});

imgRotationInput.addEventListener('input', () => {
    imgRotationAngle = parseInt(imgRotationInput.value) || 0;
    updateImgRotation();
});

// Reset-Buttons
imgResetBtn.addEventListener('click', () => {
    imgXPosition = imgInitialPosition.x;
    imgYPosition = imgInitialPosition.y;
    imgRotationAngle = 0;
    updateImgPosition();
    updateImgRotation();
});

imgResetRotationBtn.addEventListener('click', () => {
    imgRotationAngle = 0;
    updateImgRotation();
});

// Aktualisierungsfunktionen
function updateImgPosition() {
    imgPreviewElem.style.transform = `translateX(${imgXPosition}px) translateY(${imgYPosition}px) rotate(${imgRotationAngle}deg)`;
    imgXInput.value = imgXPosition + 'px';
    imgYInput.value = imgYPosition + 'px';
}

function updateImgRotation() {
    imgPreviewElem.style.transform = `translateX(${imgXPosition}px) translateY(${imgYPosition}px) rotate(${imgRotationAngle}deg)`;
    imgRotationInput.value = imgRotationAngle + 'deg';
}

// Funktion zur Anpassung der Bildbreite und Höhe in Pixeln
handleImgButton(imgPlusBtn, () => {
    imgWidthPx = Math.min(imgWidthPx + 5, imgPreviewElem.parentElement.clientWidth); // Maximal Breite des Containers
    updateImgDimensions();
});

handleImgButton(imgMinusBtn, () => {
    imgWidthPx = Math.max(imgWidthPx - 5, 10); // Minimal 10px
    updateImgDimensions();
});

function updateImgDimensions() {
    imgPreviewElem.setAttribute('width', imgWidthPx + 'px');
    imgPreviewElem.setAttribute('height', imgWidthPx + 'px'); // Gleiche Höhe wie Breite
    imgWidthValueElem.textContent = imgWidthPx + 'px';
    imgSizeAdjusted.value = imgWidthPx + 'px'; // Aktualisierte Größe eintragen
}